import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import * as tracPage from '@webapp/sdk/tracpage';
import { Actions } from '../../actions';
import {
  UpdateTracPage,
  UpdateTracPageError,
  UpdateTracPageSuccess,
} from '../action-creators';
import { UPDATE_TRAC_PAGE } from '../actions';
import AppState from '../../state';
import { TracPage } from '@services/tracpage/types/trac-page';
import { hasPlanFeature } from '@webapp/sdk/plans';
import { PlanNames } from '@services/product/types/plan-names';
import { updatedTracPageSideEffect } from '@webapp/utils/artists/update-tracpage-rudderstack';

export const updateTracPageEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, UpdateTracPage<TracPage>>(UPDATE_TRAC_PAGE),
    withLatestFrom(state$),
    filter(
      ([action, state]) =>
        !!state.artist.active?.id && action.pageType === 'tracpage'
    ),
    mergeMap(async ([action, state]) => {
      try {
        const payload: TracPage = {
          ...action.tracPage,
          subdomain: state.subdomain.currentSubdomain?.subdomain || '',
          removeBranding: hasPlanFeature(
            (state.subscription.current?.plan.toLowerCase() as PlanNames) ||
              'beginner',
            'RELEASE.REMOVE_BRANDING'
          ),
        };

        const trackPage = await tracPage.update(
          state.artist.active?.id as string,
          payload
        );

        if (state.artist.active) {
          await updatedTracPageSideEffect({
            artistData: state.artist.active,
            artistTracPage: trackPage,
          });
        }

        return new UpdateTracPageSuccess<TracPage>('tracpage', trackPage);
      } catch (err) {
        return new UpdateTracPageError(err.message);
      }
    })
  );
